import React, { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import { Case, If } from "~/common/components/If";
import TabMenu from "~/common/components/TabMenu";
import useAlert from "~/common/hooks/useAlert";
import darkProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { EyeHiddenIcon, EyeShowIcon } from "~/assets/svg/InterfaceIcon";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { AppManContext } from "../../RoundManContext";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";

const confirmSettings = {
	arrows: true,
	dots: false,
	infinite: false,
	speed: 500,
	slidesToShow: 11,
	slidesToScroll: 1,
	responsive: [
		{
			breakpoint: 1100,
			settings: {
				slidesToShow: 8,
			},
		},
	],
};

const ModalFinish = () => {
	const { t } = useTranslation();
	const { setModi, tidx, fin, setFin } = useContext(AppManContext);
	const viewRequest = useRequest("get", "vc/round/detail");
	const [data, setData] = useState({});
	const [currentSetupTab, setCurrentSetupTab] = useState("judge");
	const [showCopyAlert, CopyAlert] = useAlert();
	const [pwShow, setPwShow] = useState(false);
	const urlText = `${window.location.origin}/externalRound/${tidx}`;

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	useEffect(() => {
		switch (viewRequest.state) {
			case API_STATE.done:
				const requestCompanyView = viewRequest.response?.data;
				setData(requestCompanyView);
				break;
			default:
				break;
		}
	}, [viewRequest.state, viewRequest.response]);

	useEffect(() => {
		if (fin) {
			viewRequest.call(tidx, "path");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fin]);

	const category = data?.round?.Review?.Category || [];
	const judgesExternal = data?.judge?.filter((d) => d.external === true) || [];
	const judgesAttend =
		data?.judge?.filter((d) => d.external === false && d.role === "심사참여") || [];
	const judgesWatch =
		data?.judge?.filter((d) => d.external === false && d.role === "심사관망") || [];

	const tabMenuSetupList = [
		{
			id: "judge",
			title: `${t("pages.round.RoundManage.modal.evaluationSetting.ModalFinish.judge")}(${
				judgesAttend?.length
			})`,
		},
		{
			id: "watch",
			title: `${t("pages.round.RoundManage.modal.evaluationSetting.ModalFinish.watch")}(${
				judgesWatch?.length
			})`,
		},
		{
			id: "external",
			title: `${t("pages.round.RoundManage.modal.evaluationSetting.ModalFinish.external")}(${
				judgesExternal?.length
			})`,
		},
	];

	const handleModify = () => {
		setFin(false);
		setModi(true);
	};

	const copyClipBoard = async () => {
		try {
			await navigator.clipboard.writeText(urlText);
			showCopyAlert();
		} catch (error) {
			alert(t("pages.round.RoundManage.modal.evaluationSetting.ModalFinish.alert"));
		}
	};

	return (
		<>
			<ModalTemplate
				modalState={fin}
				setModalToggle={setFin}
				title={
					<>
						{t("pages.round.RoundManage.modal.evaluationSetting.ModalFinish.title")}
						<h3>{data?.round?.title}</h3>
					</>
				}
				width={1100}
				className="evaluate-setup-modal"
			>
				<div className="modal-content setupConfirm">
					<div className="evaluate-setup-header">
						<p className="main-desc">
							{t(
								"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.mainDesc"
							)}
						</p>
					</div>
					<div className="c__card setup-card">
						<div className="setup-wrap judge">
							<div className="external-link-wrap">
								<p className="external-link">{urlText}</p>
								<button
									type="button"
									className="btn__outline angled"
									color="primary"
									onClick={() => copyClipBoard()}
								>
									{t(
										"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.button"
									)}
								</button>
							</div>
							<TabMenu
								tabItem={tabMenuSetupList}
								currentTab={currentSetupTab}
								setCurrentTab={setCurrentSetupTab}
							/>
							<If condition={currentSetupTab}>
								<Case condition={"judge"}>
									<Slider {...confirmSettings} className="vc-confirm-carousel">
										{judgesAttend?.map((d, idx) => (
											<div className="member-box" key={idx}>
												<img
													src={
														d?.User?.img ||
														(theme === "dark"
															? darkProfileImg
															: lightProfileImg)
													}
													alt={t(
														"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.imageAlt"
													)}
												/>
												<p className="judge-name">{d.name}</p>
											</div>
										))}
									</Slider>
								</Case>
								<Case condition={"watch"}>
									<Slider {...confirmSettings} className="vc-confirm-carousel">
										{judgesWatch?.map((d, idx) => (
											<div className="member-box" key={idx}>
												<img
													src={
														d?.User?.img ||
														(theme === "dark"
															? darkProfileImg
															: lightProfileImg)
													}
													alt={t(
														"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.imageAlt"
													)}
												/>
												<p className="judge-name">{d.name}</p>
											</div>
										))}
									</Slider>
								</Case>
								<Case condition={"external"}>
									<div className="external-vc-list">
										<ul className="scroll-wrap">
											<li className="thead">
												<div className="td-num">No</div>
												<div className="td-name">
													{t(
														"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.externalTable.tableHead01"
													)}
												</div>
												<div className="td-id">
													{t(
														"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.externalTable.tableHead02"
													)}
												</div>
												<div className="td-pwd">
													{t(
														"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.externalTable.tableHead03"
													)}
												</div>
												<div className="td-mail">
													{t(
														"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.externalTable.tableHead04"
													)}
												</div>
											</li>
											{judgesExternal?.map((d, idx) => {
												return (
													<li className="passwordShow hidden" key={idx}>
														<div className="td-num">{idx + 1}</div>
														<div className="td-name">{d.name}</div>
														<div className="td-id">{d.id}</div>
														<div className="td-pwd">
															{pwShow ? (
																<p>
																	&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;
																</p>
															) : (
																<p>{d.pw}</p>
															)}
														</div>
														<div className="td-mail">{d.email}</div>
														<button
															type="button"
															className="td-toggle"
															onClick={() => setPwShow(!pwShow)}
														>
															{pwShow ? (
																<EyeHiddenIcon />
															) : (
																<EyeShowIcon />
															)}
														</button>
													</li>
												);
											})}
										</ul>
									</div>
									<p className="external-vc-notice">
										{t(
											"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.notice"
										)}
									</p>
								</Case>
							</If>
						</div>
						<div className="setup-wrap category">
							<h4 className="setup-title">
								{t(
									"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.categoryTitle"
								)}
							</h4>
							<ul className="category-table">
								<li className="single-category table-head">
									<p className="main-category">
										{t(
											"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.categoryTable.tableHead01"
										)}
									</p>
									<p className="sub-category">
										{t(
											"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.categoryTable.tableHead02"
										)}
									</p>
									<span className="weight">
										{t(
											"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.categoryTable.tableHead03"
										)}
									</span>
								</li>
								{category.map((d, idx) => (
									<li className="single-category" key={idx}>
										<p className="main-category">{d.title}</p>
										<p className="sub-category">
											{d.Item?.map((d, idx) => (
												<p key={idx}>{d.content}</p>
											))}
										</p>
										<span className="weight">
											<p className="percent-box">{`${d.weight}%`}</p>
										</span>
									</li>
								))}
							</ul>
						</div>
						{data?.round?.noticeTitle && data?.round?.noticeContent ? (
							<div className="setup-wrap notice">
								<h4 className="setup-title">
									{t(
										"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.noticeTitle"
									)}
								</h4>
								<div className="scroll-wrap">
									<div className="notice-content">
										<p className={"notice-title"}>{data?.round?.noticeTitle}</p>
										<diV>
											{data?.round?.noticeContent?.split("\n").map((text) => {
												return (
													<span>
														{text}
														<br />
													</span>
												);
											})}
										</diV>
									</div>
								</div>
							</div>
						) : (
							<></>
						)}
					</div>
				</div>
				<div className="modal-footer">
					{data?.round?.status !== "심사중" && data?.round?.status !== "종료" && (
						<button
							type="button"
							className="btn__solid"
							color="gray"
							onClick={handleModify}
						>
							{t(
								"pages.round.RoundManage.modal.evaluationSetting.ModalFinish.modify"
							)}
						</button>
					)}
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={() => setFin(false)}
					>
						{t("pages.round.RoundManage.modal.evaluationSetting.ModalFinish.confirm")}
					</button>
				</div>
			</ModalTemplate>
			<CopyAlert
				message={t("pages.round.RoundManage.modal.evaluationSetting.ModalFinish.copyAlert")}
				type="success"
				confirm={t("pages.round.RoundManage.modal.evaluationSetting.ModalFinish.confirm")}
			/>
		</>
	);
};

export default ModalFinish;
